import { render } from "./SomePage.vue?vue&type=template&id=6f905b24"
import script from "./SomePage.vue?vue&type=script&lang=js"
export * from "./SomePage.vue?vue&type=script&lang=js"

import "./SomePage.vue?vue&type=style&index=0&id=6f905b24&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__